import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  PopoverBody,
  Row,
  UncontrolledPopover,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import action from "../../assets/icons/action.svg";
import {
  fetchModules,
  postOrderId,
  updateModuleStatus,
} from "../../services/Inventory/inventory";
import { toastError, toastSuccess } from "../../helpers/msg_helper";
import EditModules from "./edit";
import ModuleFilter from "./filter";
import DashboardIcon from "../../assets/icons/iconComponents/dashboardIcon";
import ProjectManagementIcon from "../../assets/icons/iconComponents/projectManagementIcon";
import EstimateIcon from "../../assets/icons/iconComponents/estimateIcon";
import ProductMasterIcon from "../../assets/icons/iconComponents/productMasterIcon";
import ProcurementIcon from "../../assets/icons/iconComponents/procurementIcon";
import HrmsIcon from "../../assets/icons/iconComponents/hrmsIcon";
import SettingsIcon from "../../assets/icons/iconComponents/settingsIcon";
import FinanceIcon from "../../assets/icons/iconComponents/financeIcon";
import CentralStoreIcon from "../../assets/icons/iconComponents/centralStoreIcon";
import { useNavigate, useParams } from "react-router-dom";
import SortableList, { SortableItem } from "react-easy-sort";
import arrayMove from "array-move";

const ModulesIndex = () => {
  const companyname = localStorage.getItem("companyname");
  document.title = `Permissions${companyname ? ` | ${companyname}` : "MEP -Hub"}`;

  const [page, setPage] = useState("");
  const [modules, setModules] = useState();
  const [menuData, setMenuData] = useState([]);
  const [status, setStatus] = useState("");
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(0);
  const [dataPerPage, setDataPerPage] = useState(25);
  const [editModules, setEditModules] = useState({ modal: false, value: "" });

  const navigate = useNavigate();
  const { id } = useParams();

  const iconMap = {
    dashImg: DashboardIcon,
    projectImg: ProjectManagementIcon,
    estimateImg: EstimateIcon,
    productMasterImg: ProductMasterIcon,
    procureImg: ProcurementIcon,
    hrmsImg: HrmsIcon,
    settingsImg: SettingsIcon,
    financeImg: FinanceIcon,
    centralStoreImg: CentralStoreIcon,
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchModules({
          params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${
            search ? `&searchText=${search}` : "&searchText"
          }${page ? `&page=${page}` : ""}${
            dataPerPage ? `&sizePerPage=${dataPerPage}` : ""
          }${id ? `&is_submodule=${id}` : ""}`,
        });
        console.log("API Response:", response);
        setModules(response);
        setMenuData(response?.data || []);
      } catch (error) {
        console.error("Error fetching modules:", error);
        toastError("Failed to load modules");
        setMenuData([]);
      }
    };
    fetchData();
  }, [count, status, search, page, dataPerPage, id]);

  const handleEdit = (item) => {
    setEditModules({ value: item, modal: true });
  };

  const handleStatus = async (id) => {
    try {
      const response = await updateModuleStatus(id);
      toastSuccess(response?.message);
      setCount(count + 1);
    } catch (err) {
      toastError(err?.message);
    }
  };

  const handlePaginate = (page) => {
    setPage(page);
  };

  const handleUpdate = () => {
    setCount(count + 1);
  };

  const handleResetValue = () => {
    setEditModules("");
  };

  const handleStatusChange = (id) => {
    setStatus(id);
    setPage(1);
  };

  const handleSearchChange = (data) => {
    setSearch(data);
    setPage(1);
  };

  const handleSizePerPageChange = (size) => {
    setDataPerPage(size);
  };

  const handleSorting = async (newArray) => {
    try {
      const permissions = newArray?.map((dt, i) => ({
        id: dt?.id,
        order_id: i
      }));
  
      const response = await postOrderId({ permissions });
      toastSuccess(response?.message);
    } catch (err) {
      toastError(err?.message)
    }
  };
  

  const onSortEnd = (oldIndex, newIndex) => {
    setMenuData((prevArray) => {
      const newArray = arrayMove(prevArray, oldIndex, newIndex);
      console.log("New Array Order:", newArray);
  
      // Call handleSorting here with the updated order
      handleSorting(newArray);
  
      return newArray;
    });
  };
  

  console.log(`menuData`, menuData);
  

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Permissions"
              breadcrumbObject={[
                { title: "Settings", link: "/settings" },
                { title: "Permissions", link: "/settings-permission" },
              ]}
            />
            <EditModules
              onUpdate={handleUpdate}
              onReset={handleResetValue}
              buttonLabel="+ Permission"
              className="px-2 mb-3 me-2 btn btn-primary"
              editItem={editModules}
            />
          </div>
          <Card className="me-2 px-2 pb-2 permission-main-card">
            <ModuleFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
            />
            <hr className="table-divide" />
            <Row className="mt-2">
              {menuData?.length > 0 ? (
                <SortableList
                  onSortEnd={onSortEnd}
                  className="list"
                  draggedItemClassName="dragged"
                >
                  {menuData.map((dt) => {
                    const IconComponent = iconMap[dt?.icon] || EstimateIcon;
                    const hasChildren = dt?.childmodules_count > 0;

                    const handleNavigate = () => {
                      if (hasChildren) {
                        navigate(`/settings-permission/${dt?.id}`);
                      }
                    };

                    return (
                      <SortableItem key={dt?.id}>
                        <div
                          className={`sortable-card ${
                            hasChildren ? "pointer" : ""
                          }`}
                          onClick={handleNavigate}
                        >
                          <Card>
                            <CardBody>
                              <div className="d-flex justify-content-between">
                                <div className="d-flex align-items-center gap-2">
                                  {IconComponent && (
                                    <IconComponent className="menu-icons" />
                                  )}
                                  {dt?.name}
                                </div>
                                <div onClick={(e) => e.stopPropagation()}>
                                  <span id={`PopoverLegacy-${dt?.id}`}>
                                    <img src={action} alt="" className="pointer" />
                                  </span>
                                  <UncontrolledPopover
                                    placement="bottom"
                                    target={`PopoverLegacy-${dt?.id}`}
                                    trigger="legacy"
                                  >
                                    <PopoverBody>
                                      <div
                                        className="table-popup-content"
                                        onClick={() => handleEdit(dt)}
                                      >
                                        Edit
                                      </div>
                                      <div
                                        className={`${
                                          dt?.status === 1 ? "popover-border" : ""
                                        } table-popup-content`}
                                        onClick={() => handleStatus(dt?.id)}
                                      >
                                        {dt?.status === 1 ? "Deactivate" : "Activate"}
                                      </div>
                                    </PopoverBody>
                                  </UncontrolledPopover>
                                </div>
                              </div>
                              <div className="d-flex justify-content-between mt-4">
                                <div>{dt?.slug}</div>
                                <div
                                  className={`font-13 ${
                                    dt?.status === 1
                                      ? "status-active"
                                      : "status-inactive"
                                  }`}
                                >
                                  {dt?.status === 1 ? "Active" : "Inactive"}
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </div>
                      </SortableItem>
                    );
                  })}
                </SortableList>
              ) : (
                <div>No modules available</div>
              )}
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ModulesIndex;